class Auth extends EventTarget {
  constructor({ apiKey, clientId }) {
    super();

    this.apiKey = apiKey;
    this.clientId = clientId;
  }

  init() {
    return new Promise((resolve, reject) => {
      window.gapi.load('client:auth2', async () => {
        try {
          await window.gapi.client.init({
            apiKey: this.apiKey,
            clientId: this.clientId,
            discoveryDocs: [
              'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest',
              'https://sheets.googleapis.com/$discovery/rest?version=v4',
            ],
            scope:
              'https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/spreadsheets',
          });

          window.gapi.auth2
            .getAuthInstance()
            .isSignedIn.listen(status =>
              status
                ? this.dispatchEvent(new Event('loggedIn'))
                : this.dispatchEvent(new Event('loggedOut'))
            );

          resolve(window.gapi);
        } catch (error) {
          reject(new Error(error.error.message));
        }
      });
    });
  }
}

export default Auth;
